import { theme } from '@theme';
import { FC } from 'react';
import Tooltip from '../../../../shared/tooltip/Tooltip';
import { Icon, Typography } from '../../../../style';

type BpsHeaderProps = {
  iconType: string;
  iconSize: number;
  toolTipText: string;
};

const BpsHeader: FC<BpsHeaderProps> = ({ iconSize, iconType, toolTipText }) => {
  const getTrigger = (): JSX.Element => {
    return <Icon size={iconSize} type={iconType} className='bps-header' data-testid='bps-header' />;
  };

  const getContent = (): JSX.Element => {
    return (
      <Typography size={theme.typography.h5} color={theme.palette.lightGray}>
        {toolTipText}
      </Typography>
    );
  };

  return <Tooltip trigger={getTrigger()} content={getContent()} cssClass='portfolio-tooltip' />;
};

export default BpsHeader;
